"use client";

import { useState, useEffect } from "react";
import { Provider } from "jotai";
import { getAtomStore, subscribeToStoreReset } from "@lib/atoms";

export const AtomProvider = ({ children }: { children: React.ReactNode }) => {
  // Use state to force re-render when store is reset
  const [store, setStore] = useState(() => getAtomStore());

  useEffect(() => {
    // Subscribe to store reset events (triggered on logout)
    const unsubscribe = subscribeToStoreReset(() => {
      console.log("[AtomProvider] Store reset detected, updating provider");
      setStore(getAtomStore());
    });
    return unsubscribe;
  }, []);

  return <Provider store={store}>{children}</Provider>;
};
